export default class Language {
    constructor(Rest) {
        this.rest = Rest.rest;
    }

    all() {
        return this.rest.one('languages').get();
    };

    find(id) {
        return this.rest.one('language/' + id).get();
    };
};